// src/services/hotelBookingService.js
const API_URL = process.env.REACT_APP_API_URL;

// Optional helper – format yyyy-MM-dd from Date/string
export const formatDateOnly = (dateStr) => {
  if (!dateStr) return "";
 
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export async function checkAvailability(listingId, start, end) {
  const url = `${API_URL}/bookings/check-availability?listing_id=${listingId}&start=${start}&end=${end}`;
  const res = await fetch(url);
  return res.json();
}

export async function createBooking(payload) {
  const res = await fetch(`${API_URL}/bookings`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function fetchPaymentMethodsForListing(listingId) {
  const res = await fetch(`${API_URL}/hotels/listings/${listingId}/payment-methods`);
  return res.json(); // returns [3,4,5] etc.
}


export const startKokoPayment = async (bookingData) => {
  try {
    const res = await fetch(`${API_URL}/payment/koko/start`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(bookingData), 
    });

    const data = await res.json();

    if (!data || !data.actionUrl || !data.fields) {
      console.error("Koko start API returned invalid data:", data);
      alert("Koko payment service is temporarily unavailable.");
      return;
    }

    const { actionUrl, fields } = data;
    
    if (!fields || Object.keys(fields).length === 0) {
      console.error("Koko fields are empty:", fields);
      alert("Koko payment service is temporarily unavailable.");
      return;
    }

    const form = document.createElement("form");
    form.method = "POST";
    form.action = actionUrl;

    Object.entries(fields).forEach(([key, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit(); // Redirect to Koko
  } catch (err) {
    console.error("startKokoPayment error:", err);
  }
};


export const startKokoTourPayment = async (bookingPayload) => {
  try {
    const response = await fetch(`${API_URL}/payment/koko/tour/start`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(bookingPayload),
    });

    return response.json(); // { actionUrl, fields }
  } catch (err) {
    console.error("KOKO Start Payment Error:", err);
    throw err;
  }
};




// Update payment status after success
export async function updatePaymentStatus(bookingId, payment_method_id) {
  const res = await fetch(
    `${API_URL}/payment/update-payment-status/${bookingId}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ payment_method_id }),
    }
  );
  return res.json();
}


